import { MerchantOrderType } from './HandleStatusChange';

/**
 * Order types that may carry STORE_ASSET lines. Mirrors STORE_ASSET_ORDER_TYPES
 * in colugo's merchantOrderCoreUtils — the eventless outbound types that produce
 * an open-system picking job. colugo's assertItemTypeLinesAllowedOnOrder rejects
 * anything else the moment the order is edited through updateOpsOrder, so keep
 * the two lists in step.
 *
 * The Razor POST /MerchantOrder/Create has no equivalent check, so this is
 * currently the only thing standing between a user and an order colugo will
 * later refuse.
 */
export const STORE_ASSET_ORDER_TYPES: number[] = [
  MerchantOrderType.Resupply,
  MerchantOrderType.Onboarding,
  MerchantOrderType.OnboardingS,
  MerchantOrderType.OnboardingM,
  MerchantOrderType.OnboardingL,
  MerchantOrderType.Special,
  MerchantOrderType.Sample,
  MerchantOrderType.WarehouseTransfer,
];

export function orderTypeAllowsStoreAssets(
  orderType: string | number,
): boolean {
  return STORE_ASSET_ORDER_TYPES.includes(parseInt(String(orderType), 10));
}
